
import { Component, Vue } from "vue-property-decorator";
import WorldCupComponent from "@/libs/WorldCupComponent";
import MenuItem from "@/components/Navbar/MenuItem.vue";

@Component({
  components: { MenuItem }
})
export default class Unknown extends WorldCupComponent {
  isMounted: boolean;

  get links(): Array<any> {
    let links = this.getOption().navbar.items;
    if (links.length <= 0) {
      return [{ label: "NEWS", href: "../news" },
        { label: "FIXTURES", href: "../fixtures" },
        { label: "RESULTS", href: "../news" },
        { label: "TABLE", href: "../table" },
        { label: "KNOCKOUT", href: "../knockout" },
        { label: "WHERE TO WATCH", href: "../where-to-watch" }];
    }

    return links;
  }

  get title(): string {
    return this.getOption().navbar.title;
  }

  mounted() {
    this.isMounted = true;
    this.onDebug(this, "Menu:mounted", {});
    var button = document.getElementById("slide");
    button.onclick = function() {
      var container = document.getElementById("container");
      sideScroll(container, "right", 25, 100, 10);
    };

    var back = document.getElementById("slideBack");
    back.onclick = function() {
      var container = document.getElementById("container");
      sideScroll(container, "left", 25, 100, 10);
    };

    function sideScroll(element, direction, speed, distance, step) {
      var scrollAmount = 0;
      var slideTimer = setInterval(function() {
        var btnSlide = document.getElementById("slide");
        var btnSlideBack = document.getElementById("slideBack");

        if (direction == "left") {
          element.scrollLeft -= step * 4;
          btnSlideBack.classList.add("btn-hide");
          btnSlide.classList.remove("btn-hide");
        } else {
          element.scrollLeft += step * 4;
          btnSlideBack.classList.remove("btn-hide");
          btnSlide.classList.add("btn-hide");
        }
        scrollAmount += step;
        if (scrollAmount >= distance) {
          window.clearInterval(slideTimer);
        }
      }, speed);
    }

    // Stick on scroll
    if($(window).width() >= 920){
      $(window).bind('scroll', function () {
        if ($(window).scrollTop() > 352.8) {
          $('#navigationMenu').addClass('wc-sticky-header');
        } else {
          $('#navigationMenu').removeClass('wc-sticky-header');
        }
      });
    } else {
      if( /alamofire|CNA-mobileapp-Android/i.test(navigator.userAgent) || /alamofire|CNA-mobileapp-iOS/i.test(navigator.userAgent) || /alamofire|iOS/i.test(navigator.userAgent) || /alamofire|iPhone/i.test(navigator.userAgent) ) {
        $(window).bind('scroll', function () {
          if ($(window).scrollTop() > 281.44) {
            $('#navigationMenu').addClass('wc-sticky-header-mobile');
          } else {
            $('#navigationMenu').removeClass('wc-sticky-header-mobile');
          }
        });
      } else {
        $(window).bind('scroll', function () {
          if ($(window).scrollTop() > 281.44) {
            $('#navigationMenu').addClass('wc-sticky-header');
          } else {
            $('#navigationMenu').removeClass('wc-sticky-header');
          }
        });
      }
    }
  }
}
